import React from 'react';
import { Dropdown, Button, MenuProps } from 'antd';
import { SunOutlined, MoonOutlined, DesktopOutlined } from '@ant-design/icons';
import { useThemeContext } from '../contexts/ThemeContext';

export const ThemeSwitcher: React.FC = () => {
  const { theme, setTheme } = useThemeContext();
  
  const items: MenuProps['items'] = [
    {
      key: 'light',
      icon: <SunOutlined />,
      label: 'Light',
      onClick: () => setTheme('light'),
    },
    {
      key: 'dark',
      icon: <MoonOutlined />,
      label: 'Dark',
      onClick: () => setTheme('dark'),
    },
    {
      key: 'system',
      icon: <DesktopOutlined />,
      label: 'System',
      onClick: () => setTheme('system'),
    },
  ];

  const getIcon = () => {
    switch (theme) {
      case 'light':
        return <SunOutlined />;
      case 'dark':
        return <MoonOutlined />;
      case 'system':
        return <DesktopOutlined />;
      default:
        return <DesktopOutlined />;
    }
  };

  return (
    <Dropdown
      menu={{ items }}
      placement="bottomRight"
      trigger={['click']}
    >
      <Button
        type="text"
        icon={getIcon()}
        style={{ color: 'inherit' }}
      />
    </Dropdown>
  );
};